import { BaseNomDTO, PatientDTO } from "../ClientDTO";


export class ShoppingCartDTO implements IShoppingCartDTO {
    id?: number;
    writeRevision?: boolean | null;
    shoppingCartStatus?: BaseNomDTO;
    shoppingCartType?: BaseNomDTO;
    shoppingCartPaymentType?: BaseNomDTO;
    shoppingCartIdentity?: string | null;
    patient?: PatientDTO;
    onlineTransaction?: OnlineTransactionDTO;

    constructor(data?: IShoppingCartDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.writeRevision = _data["writeRevision"] !== undefined ? _data["writeRevision"] : <any>null;
            this.shoppingCartStatus = _data["shoppingCartStatus"] ? BaseNomDTO.fromJS(_data["shoppingCartStatus"]) : <any>null;
            this.shoppingCartType = _data["shoppingCartType"] ? BaseNomDTO.fromJS(_data["shoppingCartType"]) : <any>null;
            this.shoppingCartPaymentType = _data["shoppingCartPaymentType"] ? BaseNomDTO.fromJS(_data["shoppingCartPaymentType"]) : <any>null;
            this.shoppingCartIdentity = _data["shoppingCartIdentity"] !== undefined ? _data["shoppingCartIdentity"] : <any>null;
            this.patient = _data["patient"] ? PatientDTO.fromJS(_data["patient"]) : <any>null;
            this.onlineTransaction = _data["onlineTransaction"] ? OnlineTransactionDTO.fromJS(_data["onlineTransaction"]) : <any>null;
        }
    }

    static fromJS(data: any): ShoppingCartDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ShoppingCartDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["writeRevision"] = this.writeRevision !== undefined ? this.writeRevision : <any>null;
        data["shoppingCartStatus"] = this.shoppingCartStatus ? this.shoppingCartStatus.toJSON() : <any>null;
        data["shoppingCartType"] = this.shoppingCartType ? this.shoppingCartType.toJSON() : <any>null;
        data["shoppingCartPaymentType"] = this.shoppingCartPaymentType ? this.shoppingCartPaymentType.toJSON() : <any>null;
        data["shoppingCartIdentity"] = this.shoppingCartIdentity !== undefined ? this.shoppingCartIdentity : <any>null;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>null;
        data["onlineTransaction"] = this.onlineTransaction ? this.onlineTransaction.toJSON() : <any>null;
        return data;
    }
}

export interface IShoppingCartDTO {
    id?: number;
    writeRevision?: boolean | null;
    shoppingCartStatus?: BaseNomDTO;
    shoppingCartType?: BaseNomDTO;
    shoppingCartPaymentType?: BaseNomDTO;
    shoppingCartIdentity?: string | null;
    patient?: PatientDTO;
    onlineTransaction?: OnlineTransactionDTO;
}


export class OnlineTransactionDTO implements IOnlineTransactionDTO {
    paymentReference?: string | null;
    price?: number | null;
    paymentDate?: Date | null;
    limitDate?: Date | null;

    constructor(data?: IOnlineTransactionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentReference = _data["paymentReference"] !== undefined ? _data["paymentReference"] : <any>null;
            this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
            this.paymentDate = _data["paymentDate"] ? new Date(_data["paymentDate"].toString()) : <any>null;
            this.limitDate = _data["limitDate"] ? new Date(_data["limitDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): OnlineTransactionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OnlineTransactionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentReference"] = this.paymentReference !== undefined ? this.paymentReference : <any>null;
        data["price"] = this.price !== undefined ? this.price : <any>null;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>null;
        data["limitDate"] = this.limitDate ? this.limitDate.toISOString() : <any>null;
        return data;
    }
}

export interface IOnlineTransactionDTO {
    paymentReference?: string | null;
    price?: number | null;
    paymentDate?: Date | null;
    limitDate?: Date | null;
}


export class ShoppingCartInternalItemDTO implements IShoppingCartInternalItemDTO {
    id?: number;
    writeRevision?: boolean | null;
    shoppingCartItemStatus?: BaseNomDTO;
    service?: PublicServiceDTO;
    shoppingCart?: ShoppingCartDTO;
    additionalParameters?: string | null;

    constructor(data?: IShoppingCartInternalItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.writeRevision = _data["writeRevision"] !== undefined ? _data["writeRevision"] : <any>null;
            this.shoppingCartItemStatus = _data["shoppingCartItemStatus"] ? BaseNomDTO.fromJS(_data["shoppingCartItemStatus"]) : <any>null;
            this.service = _data["service"] ? PublicServiceDTO.fromJS(_data["service"]) : <any>null;
            this.shoppingCart = _data["shoppingCart"] ? ShoppingCartDTO.fromJS(_data["shoppingCart"]) : <any>null;
            this.additionalParameters = _data["additionalParameters"] !== undefined ? _data["additionalParameters"] : <any>null;
        }
    }

    static fromJS(data: any): ShoppingCartInternalItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ShoppingCartInternalItemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["writeRevision"] = this.writeRevision !== undefined ? this.writeRevision : <any>null;
        data["shoppingCartItemStatus"] = this.shoppingCartItemStatus ? this.shoppingCartItemStatus.toJSON() : <any>null;
        data["service"] = this.service ? this.service.toJSON() : <any>null;
        data["shoppingCart"] = this.shoppingCart ? this.shoppingCart.toJSON() : <any>null;
        data["additionalParameters"] = this.additionalParameters !== undefined ? this.additionalParameters : <any>null;
        return data;
    }
}

export interface IShoppingCartInternalItemDTO {
    id?: number;
    writeRevision?: boolean | null;
    shoppingCartItemStatus?: BaseNomDTO;
    service?: PublicServiceDTO;
    shoppingCart?: ShoppingCartDTO;
    additionalParameters?: string | null;
}
export class PublicServiceDTO implements IPublicServiceDTO {
    id?: number;
    name?: string | null;
    price?: number | null;
    image?: string | null;
    description?: string | null;
    tag?: string | null;
    category?: ServiceGroupDTO;
    portalUrl?: string | null;

    constructor(data?: IPublicServiceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
            this.image = _data["image"] !== undefined ? _data["image"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.tag = _data["tag"] !== undefined ? _data["tag"] : <any>null;
            this.category = _data["category"] ? ServiceGroupDTO.fromJS(_data["category"]) : <any>null;
            this.portalUrl = _data["portalUrl"] !== undefined ? _data["portalUrl"] : <any>null;
        }
    }

    static fromJS(data: any): PublicServiceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PublicServiceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["price"] = this.price !== undefined ? this.price : <any>null;
        data["image"] = this.image !== undefined ? this.image : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["tag"] = this.tag !== undefined ? this.tag : <any>null;
        data["category"] = this.category ? this.category.toJSON() : <any>null;
        data["portalUrl"] = this.portalUrl !== undefined ? this.portalUrl : <any>null;
        return data;
    }
}
export class ServiceGroupDTO implements IServiceGroupDTO {
    id?: number;
    image?: string | null;
    icon?: string | null;
    name?: string | null;
    tag?: string | null;
    description?: string | null;

    constructor(data?: IServiceGroupDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.image = _data["image"] !== undefined ? _data["image"] : <any>null;
            this.icon = _data["icon"] !== undefined ? _data["icon"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.tag = _data["tag"] !== undefined ? _data["tag"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
        }
    }

    static fromJS(data: any): ServiceGroupDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceGroupDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["image"] = this.image !== undefined ? this.image : <any>null;
        data["icon"] = this.icon !== undefined ? this.icon : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["tag"] = this.tag !== undefined ? this.tag : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        return data;
    }
}

export interface IServiceGroupDTO {
    id?: number;
    image?: string | null;
    icon?: string | null;
    name?: string | null;
    tag?: string | null;
    description?: string | null;
}
export interface IPublicServiceDTO {
    id?: number;
    name?: string | null;
    price?: number | null;
    image?: string | null;
    description?: string | null;
    tag?: string | null;
    category?: ServiceGroupDTO;
    portalUrl?: string | null;
}


export class ShoppingCartItemDTO implements IShoppingCartItemDTO {
    service?: PublicServiceDTO;
    additionalParameters?: string | null;

    constructor(data?: IShoppingCartItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.service = _data["service"] ? PublicServiceDTO.fromJS(_data["service"]) : <any>null;
            this.additionalParameters = _data["additionalParameters"] !== undefined ? _data["additionalParameters"] : <any>null;
        }
    }

    static fromJS(data: any): ShoppingCartItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ShoppingCartItemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["service"] = this.service ? this.service.toJSON() : <any>null;
        data["additionalParameters"] = this.additionalParameters !== undefined ? this.additionalParameters : <any>null;
        return data;
    }
}

export interface IShoppingCartItemDTO {
    service?: PublicServiceDTO;
    additionalParameters?: string | null;
}


export class PaymentTypeDTO implements IPaymentTypeDTO {
    id?: number;
    writeRevision?: boolean | null;
    name?: string | null;
    color?: string | null;
    tag?: string | null;

    constructor(data?: IPaymentTypeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.writeRevision = _data["writeRevision"] !== undefined ? _data["writeRevision"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.color = _data["color"] !== undefined ? _data["color"] : <any>null;
            this.tag = _data["tag"] !== undefined ? _data["tag"] : <any>null;
        }
    }

    static fromJS(data: any): PaymentTypeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentTypeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["writeRevision"] = this.writeRevision !== undefined ? this.writeRevision : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["color"] = this.color !== undefined ? this.color : <any>null;
        data["tag"] = this.tag !== undefined ? this.tag : <any>null;
        return data;
    }
}

export interface IPaymentTypeDTO {
    id?: number;
    writeRevision?: boolean | null;
    name?: string | null;
    color?: string | null;
    tag?: string | null;
}
